import {
    GET_SOCIETY_PROFILE,
    UPDATE_SOCIETY_PROFILE,
    CLEAR_SOCIETY_PROFILE
} from '../../index.types';

export function getSocietyProfile(data) {
    return {
        type: GET_SOCIETY_PROFILE,
        data
    }
}

export function updateSocietyProfile(data) {
    return {
        type: UPDATE_SOCIETY_PROFILE,
        data
    }
}

export function clearSocietyProfile() {
    return {
        type: CLEAR_SOCIETY_PROFILE
    }
}
